import { render } from "./OapMarquee.vue?vue&type=template&id=24f90353"
import script from "./OapMarquee.vue?vue&type=script&lang=js"
export * from "./OapMarquee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__